import { useState, useEffect } from "react";
import { getSignatureListByUser } from "../../../services/templateV2Service";

export const useSignatureForms = () => {
    const [signatureImage, setSignatureImage] = useState(null);

    useEffect(() => {
        getSignatureList();
    }, []);

    const getSignatureList = async () => {
        const res = await getSignatureListByUser();
        console.log("getSignatureList res", res);
        if(res.data.signatureUrl) {
            setSignatureImage(res.data.signatureUrl);
        }
    };

    return {
        signatureImage,
        getSignatureList
    };
};